(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seamless-logo-carousel')) {
    customElements.define(
      'seamless-logo-carousel',
      class SeamlessLogoCarousel extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.slider = this.querySelector('.logo-carousel__slider');
          this.originalSlides = Array.from(this.querySelectorAll('[data-logo-slide]'));
          this.previousButton = this.querySelector('[name="previous"]');
          this.nextButton = this.querySelector('[name="next"]');
          this.autoplayButton = this.querySelector('[data-autoplay-toggle]');
          this.desktopQuery = window.matchMedia('(min-width: 992px)');
          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.autoplayRequested = this.dataset.autoplay === 'true';
          this.userPaused = false;
          this.interactionPaused = false;
          this.editorPaused = false;
          this.designMode = this.dataset.designMode === 'true' || Boolean(window.Shopify?.designMode);
          this.lastWidth = 0;

          if (!this.slider || this.originalSlides.length < 2) return;

          this.onPreviousClick = () => this.move(-1);
          this.onNextClick = () => this.move(1);
          this.onAutoplayClick = () => {
            this.userPaused = !this.userPaused;
            this.updateAutoplay();
          };
          this.onPointerEnter = () => {
            this.interactionPaused = true;
            this.updateAutoplay();
          };
          this.onPointerLeave = () => {
            this.interactionPaused = false;
            this.updateAutoplay();
          };
          this.onFocusIn = (event) => {
            this.interactionPaused = true;
            const slide = event.target.closest('[data-logo-slide]');
            if (slide) this.showOriginalSlide(slide);
            this.updateAutoplay();
          };
          this.onFocusOut = (event) => {
            if (!this.contains(event.relatedTarget)) {
              this.interactionPaused = false;
              this.updateAutoplay();
            }
          };
          this.onScroll = () => {
            window.clearTimeout(this.scrollTimer);
            this.scrollTimer = window.setTimeout(() => this.normalizePosition(), 100);
          };
          this.onViewportChange = () => this.refresh();
          this.onVisibilityChange = () => this.updateAutoplay();
          this.onBlockSelect = (event) => {
            const slide = event.target.closest?.('[data-logo-slide]');
            if (!slide || !this.contains(slide)) return;
            this.editorPaused = true;
            this.showOriginalSlide(slide);
            this.updateAutoplay();
          };
          this.onBlockDeselect = () => {
            this.editorPaused = false;
            this.updateAutoplay();
          };

          this.previousButton?.addEventListener('click', this.onPreviousClick);
          this.nextButton?.addEventListener('click', this.onNextClick);
          this.autoplayButton?.addEventListener('click', this.onAutoplayClick);
          this.addEventListener('pointerenter', this.onPointerEnter);
          this.addEventListener('pointerleave', this.onPointerLeave);
          this.addEventListener('focusin', this.onFocusIn);
          this.addEventListener('focusout', this.onFocusOut);
          this.addEventListener('shopify:block:select', this.onBlockSelect);
          this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
          this.slider.addEventListener('scroll', this.onScroll, { passive: true });
          this.desktopQuery.addEventListener('change', this.onViewportChange);
          this.motionQuery.addEventListener('change', this.onViewportChange);
          document.addEventListener('visibilitychange', this.onVisibilityChange);

          this.resizeObserver = new ResizeObserver((entries) => {
            const width = entries[0]?.contentRect.width || 0;
            if (Math.abs(width - this.lastWidth) < 1) return;
            this.lastWidth = width;
            this.refresh();
          });
          this.resizeObserver.observe(this);
          this.refresh();
        }

        disconnectedCallback() {
          window.clearInterval(this.autoplayTimer);
          window.clearTimeout(this.scrollTimer);
          this.resizeObserver?.disconnect();
          this.previousButton?.removeEventListener('click', this.onPreviousClick);
          this.nextButton?.removeEventListener('click', this.onNextClick);
          this.autoplayButton?.removeEventListener('click', this.onAutoplayClick);
          this.removeEventListener('pointerenter', this.onPointerEnter);
          this.removeEventListener('pointerleave', this.onPointerLeave);
          this.removeEventListener('focusin', this.onFocusIn);
          this.removeEventListener('focusout', this.onFocusOut);
          this.removeEventListener('shopify:block:select', this.onBlockSelect);
          this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
          this.slider?.removeEventListener('scroll', this.onScroll);
          this.desktopQuery?.removeEventListener('change', this.onViewportChange);
          this.motionQuery?.removeEventListener('change', this.onViewportChange);
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
        }

        isEnabled() {
          return this.desktopQuery.matches
            ? this.dataset.desktopEnabled === 'true'
            : this.dataset.mobileEnabled === 'true';
        }

        refresh() {
          const shouldLoop = this.isEnabled() && this.originalSlides.length > 1;
          if (!shouldLoop) {
            this.classList.remove('is-looping');
            this.jumpTo(0);
            this.updateAutoplay();
            return;
          }

          this.ensureClones();
          this.classList.add('is-looping');
          window.requestAnimationFrame(() => {
            this.measure();
            this.jumpTo(this.loopWidth);
            this.updateAutoplay();
          });
        }

        ensureClones() {
          if (this.beforeClones?.length) return;
          this.beforeClones = this.originalSlides.map((slide, index) => this.cloneSlide(slide, `before-${index}`));
          this.afterClones = this.originalSlides.map((slide, index) => this.cloneSlide(slide, `after-${index}`));
          this.slider.prepend(...this.beforeClones);
          this.slider.append(...this.afterClones);
        }

        cloneSlide(slide, suffix) {
          const clone = slide.cloneNode(true);
          clone.id = `${slide.id}-${suffix}`;
          clone.removeAttribute('data-logo-slide');
          clone.removeAttribute('data-block-id');
          clone.removeAttribute('data-shopify-editor-block');
          clone.removeAttribute('data-cascade');
          clone.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          clone.style.removeProperty('--animation-order');
          clone.setAttribute('data-logo-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => element.removeAttribute('data-shopify-editor-block'));
          clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => element.setAttribute('tabindex', '-1'));
          return clone;
        }

        measure() {
          if (!this.afterClones?.length) return;
          this.itemOffset = this.originalSlides[1].offsetLeft - this.originalSlides[0].offsetLeft;
          this.loopWidth = this.afterClones[0].offsetLeft - this.originalSlides[0].offsetLeft;
        }

        move(direction) {
          if (!this.classList.contains('is-looping') || !this.itemOffset) return;
          this.slider.scrollTo({
            left: this.slider.scrollLeft + direction * this.itemOffset,
            behavior: this.motionQuery.matches ? 'auto' : 'smooth'
          });
        }

        normalizePosition() {
          if (!this.classList.contains('is-looping') || !this.loopWidth) return;
          if (this.slider.scrollLeft >= this.loopWidth * 2 - 1) {
            this.jumpTo(this.slider.scrollLeft - this.loopWidth);
          } else if (this.slider.scrollLeft <= 1) {
            this.jumpTo(this.slider.scrollLeft + this.loopWidth);
          }
        }

        jumpTo(position) {
          if (!this.slider) return;
          this.slider.classList.add('is-resetting');
          this.slider.scrollLeft = position;
          this.slider.getBoundingClientRect();
          window.requestAnimationFrame(() => this.slider?.classList.remove('is-resetting'));
        }

        showOriginalSlide(slide) {
          if (!this.classList.contains('is-looping')) return;
          window.requestAnimationFrame(() => {
            this.slider.scrollTo({
              left: slide.offsetLeft,
              behavior: this.motionQuery.matches ? 'auto' : 'smooth'
            });
          });
        }

        updateAutoplay() {
          const canAutoplay =
            this.autoplayRequested &&
            this.classList.contains('is-looping') &&
            !this.motionQuery.matches &&
            !this.designMode;
          const shouldPlay =
            canAutoplay &&
            !this.userPaused &&
            !this.interactionPaused &&
            !this.editorPaused &&
            document.visibilityState === 'visible';

          this.autoplayButton?.toggleAttribute('hidden', !canAutoplay);
          this.autoplayButton?.classList.toggle('is-paused', this.userPaused);
          if (this.autoplayButton) {
            this.autoplayButton.setAttribute(
              'aria-label',
              this.userPaused ? this.autoplayButton.dataset.playLabel : this.autoplayButton.dataset.pauseLabel
            );
          }

          window.clearInterval(this.autoplayTimer);
          this.autoplayTimer = undefined;
          this.slider?.setAttribute('aria-live', shouldPlay ? 'off' : 'polite');
          if (shouldPlay) {
            this.autoplayTimer = window.setInterval(
              () => this.move(1),
              Math.max(Number(this.dataset.speed) || 3, 3) * 1000
            );
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
